import { Http, s, Shape } from "@kosmod/pancake";
import { Room, RoomID } from "./room";
import { idDef } from "@kosmod/kit";
import { SceneSessionAction, SceneSessionEvent } from "@kosmod/theatre";
import { VoiceSessionAction, VoiceSessionEvent } from "../backend/voiceSession";
import { Game, GameID, Player, SESAME_AUTH_SUBPROTOCOL } from "@kosmod/sesame";

export const RoomSessionEvent = s.du('type', {
  'load-room': { room: Room },
  'players': { players: s.a(idDef) },
  'scene': { scene: SceneSessionEvent },
  'voice': { voice: VoiceSessionEvent },
});
export type RoomSessionEvent = Shape.Type.Of<typeof RoomSessionEvent>;

export const RoomSessionAction = s.du('type', {
  authorize: { credential: s.str },
  scene: { scene: SceneSessionAction },
  room: {},
  voice: { voice: VoiceSessionAction }
});
export type RoomSessionAction = Shape.Type.Of<typeof RoomSessionAction>;

export const CONCIERGE_ROOM_SUBPROTOCOL = `kosmod.room.v1`

export const conciergeApiDef = Http.api.Branch({
  'room': Http.endpoint.Json({
    GET: {
      query: s.o({
        gameId: GameID,
        roomId: s.optional(RoomID),
      }),
      request: s.null,
      response: s.o({
        rooms: s.a(Room)
      }),
    },
    POST: {
      query: s.null,
      request: s.o({
        name: s.str,
        gameId: GameID,
      }),
      response: s.o({
        room: Room
      }),
    }
  }),
  'room/context': Http.endpoint.Json({
    GET: {
      query: s.o({
        game: GameID,
        room: RoomID,
      }),
      request: s.null,
      response: s.du('op', {
        'ok': {
          room: Room,
          game: Game,
          self: Player
        },
        'error': {
          message: s.str,
        }
      }),
    }
  }),
  'room/join': Http.endpoint.WebSocket(
    s.object({ game: GameID, room: RoomID }),
    RoomSessionAction,
    RoomSessionEvent,
    [SESAME_AUTH_SUBPROTOCOL, CONCIERGE_ROOM_SUBPROTOCOL].join('+')
  )
});
